// src/pages/Watchlist.js
import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { getWatchlist } from "../services/firebase";
import MovieList from "../components/MovieList";
import { Link } from "react-router-dom";
import "./Watchlist.scss";

const Watchlist = () => {
    const [watchlist, setWatchlist] = useState([]);
    const [loadingWatchlist, setLoadingWatchlist] = useState(false);
    const { user, loading } = useAuth();

    useEffect(() => {
        const fetchWatchlist = async () => {
            if (user) {
                try {
                    setLoadingWatchlist(true);
                    const userWatchlist = await getWatchlist(user.uid);
                    setWatchlist(userWatchlist);
                    setLoadingWatchlist(false);
                } catch (error) {
                    console.error("Error fetching watchlist:", error);
                }
            }
        };

        fetchWatchlist();
    }, [user]);

    return (
        <div className="watchlist layout">
            <h1>Watchlist</h1>
            {loading ? (
                <p>Loading...</p>
            ) : user ? (
                <div>
                    {loadingWatchlist ? (
                        <p>Loading...</p>
                    ) : (
                        <>
                            {watchlist.length > 0 ? (
                                <MovieList movies={watchlist} />
                            ) : (
                                <p>Your watchlist is empty.</p>
                            )}
                        </>
                    )}
                </div>
            ) : (
                <div>
                    <Link className="signin_link" to="/signin">
                        SignIn
                    </Link>{" "}
                    to see your watchlist
                </div>
            )}
        </div>
    );
};

export default Watchlist;
